export default __webpack_public_path__ + "static/media/cg.f223c25c.svg";